import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo
} from 'react'

import usePopup, { PopupReturnType } from 'hooks/usePopup'
import { initialPopup } from '../../../hooks/constants'

type ContextProps = {
  assignWithRelatedItemsHSPresPopup: PopupReturnType
  assignWithoutRelatedItemsPopup: PopupReturnType
  deleteCCPopup: PopupReturnType
  reviewAndApproveCategoriesPopup: PopupReturnType
  activateWithoutCategoriesPopup: PopupReturnType
}

const CRUDUserPopupContext = createContext<ContextProps>({
  assignWithRelatedItemsHSPresPopup: initialPopup,
  assignWithoutRelatedItemsPopup: initialPopup,
  deleteCCPopup: initialPopup,
  reviewAndApproveCategoriesPopup: initialPopup,
  activateWithoutCategoriesPopup: initialPopup
})

const basePopup = (title: string) => ({
  title
})

const CRUDUserPopupProvider: FC<PropsWithChildren> = ({ children }) => {
  const assignWithRelatedItemsHSPresPopupProps = usePopup(
    basePopup('Manage category assignment')
  )
  const assignWithoutRelatedItemsPopupProps = usePopup(
    basePopup('Manage category assignment')
  )
  const deleteCCPopupProps = usePopup(basePopup('Delete contract categor'))

  const reviewAndApproveCategoriesPopupProps = usePopup(
    basePopup('Review and approve user categories')
  )
  const activateWithoutCategoriesPopupProps = usePopup(
    basePopup('Activate user without categories?')
  )
  const context = useMemo(
    () => ({
      assignWithRelatedItemsHSPresPopup: assignWithRelatedItemsHSPresPopupProps,
      assignWithoutRelatedItemsPopup: assignWithoutRelatedItemsPopupProps,
      deleteCCPopup: deleteCCPopupProps,
      reviewAndApproveCategoriesPopup: reviewAndApproveCategoriesPopupProps,
      activateWithoutCategoriesPopup: activateWithoutCategoriesPopupProps
    }),
    [
      assignWithRelatedItemsHSPresPopupProps,
      assignWithoutRelatedItemsPopupProps,
      deleteCCPopupProps,
      reviewAndApproveCategoriesPopupProps,
      activateWithoutCategoriesPopupProps
    ]
  )

  return (
    <CRUDUserPopupContext.Provider value={context}>
      {children}
    </CRUDUserPopupContext.Provider>
  )
}

export const useCRUDUserPopupProviderContext = () =>
  useContext(CRUDUserPopupContext)

export default CRUDUserPopupProvider
